var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"pa-list"},[_c('transition-group',{attrs:{"name":"fade"}},_vm._l((_vm.predictions),function(prediction,index){return _c('li',{key:index,staticClass:"pa-list__item",on:{"click":function($event){_vm.$emit('click', prediction)}}},[_vm._v("\n      "+_vm._s(prediction.title)+"\n    ")])}))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f7d7982","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaceAutocomplete/PlaceAutocompleteList.vue
// module id = null
// module chunks = 